import * as React from 'react';
import type { ReactNode } from 'react';
import { useLocale, useTranslations } from '@accenturecodefoundry/mfe-pot-shared-i18n';
import { assetBaseUrl } from '../asset-base-url';
import './SupportSection.css';

export interface SupportSectionProps {
  headingKey: string;
  children: ReactNode;
}

/**
 * Section wrapper that stacks `SupportRow` children with a shared card border.
 * The border-top on each row creates a divider effect; the outer container holds
 * the bottom border and card chrome. Self-serves locale/translations.
 */
export function SupportSection({ headingKey, children }: SupportSectionProps) {
  const locale = useLocale();
  const { t } = useTranslations(assetBaseUrl, locale);

  return (
    <section className="support-section">
      <h2 className="support-section__heading">{t(headingKey)}</h2>
      <div className="support-section__card">{children}</div>
    </section>
  );
}
